import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { RouterModule } from '@angular/router';
import { AuthenticationService } from '@app/services/authentication.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-bottom-tab-nav',
  imports: [RouterModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './bottom-tab-nav.component.html',
})
export class BottomTabNavComponent {
  @Input() isScrollingDown = false;
}
